import { normalizeApiError } from '@/lib/api/types';

export const TEMPLATE_ALIGNMENT_ERROR_CODES = new Set([
  'template_alignment_needs_input',
  'template_alignment_invalid',
]);

export function isTemplateAlignmentError(error: unknown): boolean {
  return TEMPLATE_ALIGNMENT_ERROR_CODES.has(normalizeApiError(error).code);
}

/** Render bounded text only. Provider output, links and execution internals are never UI copy. */
export function templateAlignmentQuestions(details: Record<string, unknown> | undefined): string[] {
  if (!Array.isArray(details?.questions)) return [];
  return details.questions.filter((value): value is string => typeof value === 'string')
    .map(value => value.trim())
    .filter(value => value.length > 0 && value.length <= 500 && !/https?:\/\/|<<<|```/.test(value))
    .slice(0, 3);
}
